module.exports = __webpack_public_path__ + "static/img/00.12bb4d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/04/00.jpg
// module id = fzoJ
// module chunks = 0